import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatChangeoverAnchor = createCustomElementWrapper('kat-changeover-anchor', 'KatChangeoverAnchor', {
    'alignX': 'align-x',
    'alignY': 'align-y',
    'dismissDelay': 'dismiss-delay',
}, {
    'onChange': 'change',
    'onHide': 'hide',
    'onShow': 'show',
}, [
    'cta',
]);
